import Swiper,{Navigation} from "swiper";

Swiper.use([Navigation]);

export function initSelectOnFloorSlider(){

    const $slider = $('#select_on_floor_slider');

    if (!$slider.length) {
        return
    }

    const swiper = new Swiper('#select_on_floor_slider', {
        loop:false,
        initialSlide: $slider.data('slide-active'),
        speed: 900,
        preloadImages:false,
        spaceBetween: 20,
        direction: 'vertical',
        centeredSlides: true,
        roundLengths: true,
        navigation:{
            nextEl:'.floor-swiper-button-next',
            prevEl:'.floor-swiper-button-prev'
        },
        breakpoints: {
            0: {
                direction: 'horizontal',
                slidesPerView: 5,
                spaceBetween: 0
            },
            600:{
                direction: 'horizontal',
                slidesPerView: 5,
                spaceBetween: 0
            },
            768: {
                direction: 'horizontal',
                slidesPerView: 7,
                spaceBetween: 16
            },
            1000: {
                slidesPerView: 7,
                spaceBetween: 8
            }
        }
    });

    $(window).on('resize',function (){
        if(window.screen.availWidth < 1000){
            swiper.changeDirection('horizontal',true);
        } else {
            swiper.changeDirection('vertical',true);
        }
    })
    // swiper.slideTo();


}
